import React from 'react'
import Header from '../Header/Header'
import CurrentPageContainer from './CurrentPageContainer'
import NarrowMapArea from './NarrowMapArea'
import { withStyles } from '@material-ui/core/styles'

const styles = {
	root: {
		height: '100%',
		width: '100%',
		display: 'flex',
	    flexDirection: 'column'
	},
}

const NarrowLayout = ({ pageIsOpen, classes }) => (
	<div className={classes.root}>
		<Header />
		{ pageIsOpen ? <CurrentPageContainer /> : <NarrowMapArea /> }
	</div>
)

export default withStyles(styles)(NarrowLayout)



// WEBPACK FOOTER //
// ./src/components/Layout/NarrowLayout.js